// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@disy/cadenza-icons/info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@disy/cadenza-icons/warning.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@disy/cadenza-icons/error.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-alert {
  --bg: transparent;
  --border-color: transparent;
  --color: var(--default-color);
  --icon: none;
  --icon-gap: var(--space-1);
  --icon-size: var(--space-5);
  --margin-bottom: var(--space-4);
  --p-margin: var(--space-2);
  --padding-x: var(--space-2);
  --padding-y: var(--space-3);
  --text-offset: calc((var(--icon-size) - 1lh) / 2);

  background-color: var(--bg);
  border: 1px solid var(--border-color);
  color: var(--color);
  display: block;
  padding: calc(var(--padding-y) + var(--text-offset)) var(--padding-x);
  position: relative;

  &:where(.d-alert-success, .d-alert-info, .d-alert-warning, .d-alert-error) {
    &:where(.d-alert-with-button) .d-alert--text::before,
    &:where(:not(.d-alert-with-button))::before {
      aspect-ratio: 1;
      background-color: currentColor;
      content: '';
      display: block;
      mask-image: var(--icon);
      mask-size: 100%;
      width: var(--icon-size);
    }
  }

  &:where(:not(.d-alert-small, .d-alert-xs)) {
    padding-left: calc(var(--padding-x) + var(--icon-size) + var(--icon-gap));

    &.d-alert-with-button .d-alert--text::before,
    &:not(.d-alert-with-button)::before {
      left: var(--padding-x);
      position: absolute;
      top: var(--padding-y);
    }
  }

  &:empty {
    display: none;
  }

  &:where(:not(:last-child)) {
    margin-bottom: var(--margin-bottom);
  }

  .d-alert--text {
    display: block;
  }

  p:not(:last-child) {
    margin-bottom: var(--p-margin);
  }

  /** @TechnicalDebt CADENZA-43087 */
  ul {
    list-style: square outside;
    margin-block: 0;
    margin-left: var(--space-5);
    padding: 0;

    /* reduce distance between bullet point and text to 4px */
    li span {
      left: -6px;
      position: relative;
    }
  }

  ul:has(> li > .d-label-with-icon) {
    list-style-type: none;
    margin-left: 0;
  }

  .title {
    font-weight: var(--bold-font-weight);

    &:empty {
      display: none;
    }
  }
}

.d-alert-hint {
  --bg: var(--alert-color-hint-background);
  --border-color: var(--color-gray-04);
  --color: var(--alert-color-hint);
}

.d-alert-success {
  --bg: var(--alert-color-success-background);
  --border-color: var(--color-success-04);
  --color: var(--alert-color-success);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.d-alert-info {
  --bg: var(--alert-color-info-background);
  --border-color: var(--color-info-04);
  --color: var(--alert-color-info);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.d-alert-warning {
  --bg: var(--alert-color-warning-background);
  --border-color: var(--color-warning-04);
  --color: var(--alert-color-warning);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.d-alert-error {
  --bg: var(--alert-color-error-background);
  --border-color: var(--color-error-04);
  --color: var(--alert-color-error);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

:where(.dark-bg) {
  .d-alert-success {
    --border-color: var(--color-success-05);
  }

  .d-alert-info {
    --border-color: var(--color-info-05);
  }

  .d-alert-warning {
    --border-color: var(--color-warning-05);
  }

  .d-alert-error {
    --border-color: var(--color-error-05);
  }
}

.d-alert-small,
.d-alert-xs {
  &.d-alert-with-button .d-alert--text::before,
  &:not(.d-alert-with-button)::before {
    float: left;
    margin-right: var(--icon-gap);
    margin-top: calc(-1 * var(--text-offset));
  }
}

/*
 * Unfortunately, the alert size default is not sensible, because usually we use the small size.
 * To mitigate issues with people forgetting to apply the small size, we make default alerts
 * *look* like small alerts in modals and popups.
 */

:where(.d-modal, .d-popup) .d-alert,
.d-alert-small {
  --icon-size: var(--icon-size-xs);
  --margin-bottom: var(--space-2);
  --p-margin: var(--space-1);
  --padding-y: var(--space-2);
}

.d-alert-xs {
  --icon-gap: var(--space-05);
  --margin-bottom: var(--space-1);
  --p-margin: var(--space-1);

  /* Colors */
  --alert-color-success: var(--alert-xs-color-success);
  --alert-color-info: var(--alert-xs-color-info);
  --alert-color-warning: var(--alert-xs-color-warning);
  --alert-color-error: var(--alert-xs-color-error);

  background-color: transparent;
  border: none;
  padding: 0;

  @media (hover: hover) {
    --icon-size: var(--icon-size-xs);
  }
}

.d-alert-with-button {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;

  & .d-alert--text + * {
    margin-left: var(--space-2);
  }
}

.d-alert-with-button-bottom {
  --button-gap: var(--space-2);

  & .d-alert--text ~ * {
    margin: var(--button-gap) var(--button-gap) 0 0;
  }

  &.d-alert-small {
    --button-gap: var(--space-1);
  }
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/alert/alert.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,iDAAiD;;EAEjD,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,qEAAqE;EACrE,kBAAkB;;EAElB;IACE;;MAEE,eAAe;MACf,8BAA8B;MAC9B,WAAW;MACX,cAAc;MACd,uBAAuB;MACvB,eAAe;MACf,uBAAuB;IACzB;EACF;;EAEA;IACE,yEAAyE;;IAEzE;;MAEE,sBAAsB;MACtB,kBAAkB;MAClB,qBAAqB;IACvB;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA,kCAAkC;EAClC;IACE,0BAA0B;IAC1B,eAAe;IACf,2BAA2B;IAC3B,UAAU;;IAEV,yDAAyD;IACzD;MACE,UAAU;MACV,kBAAkB;IACpB;EACF;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,oCAAoC;;IAEpC;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,mCAAmC;EACnC,+CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,+CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;EACjC,+CAA6C;AAC/C;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;;EAEE;;IAEE,WAAW;IACX,6BAA6B;IAC7B,yCAAyC;EAC3C;AACF;;AAEA;;;;EAIE;;AACF;;EAEE,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;;EAE1B,WAAW;EACX,oDAAoD;EACpD,8CAA8C;EAC9C,oDAAoD;EACpD,gDAAgD;;EAEhD,6BAA6B;EAC7B,YAAY;EACZ,UAAU;;EAEV;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;;EAE9B;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,4BAA4B;;EAE5B;IACE,+CAA+C;EACjD;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".d-alert {\n  --bg: transparent;\n  --border-color: transparent;\n  --color: var(--default-color);\n  --icon: none;\n  --icon-gap: var(--space-1);\n  --icon-size: var(--space-5);\n  --margin-bottom: var(--space-4);\n  --p-margin: var(--space-2);\n  --padding-x: var(--space-2);\n  --padding-y: var(--space-3);\n  --text-offset: calc((var(--icon-size) - 1lh) / 2);\n\n  background-color: var(--bg);\n  border: 1px solid var(--border-color);\n  color: var(--color);\n  display: block;\n  padding: calc(var(--padding-y) + var(--text-offset)) var(--padding-x);\n  position: relative;\n\n  &:where(.d-alert-success, .d-alert-info, .d-alert-warning, .d-alert-error) {\n    &:where(.d-alert-with-button) .d-alert--text::before,\n    &:where(:not(.d-alert-with-button))::before {\n      aspect-ratio: 1;\n      background-color: currentColor;\n      content: '';\n      display: block;\n      mask-image: var(--icon);\n      mask-size: 100%;\n      width: var(--icon-size);\n    }\n  }\n\n  &:where(:not(.d-alert-small, .d-alert-xs)) {\n    padding-left: calc(var(--padding-x) + var(--icon-size) + var(--icon-gap));\n\n    &.d-alert-with-button .d-alert--text::before,\n    &:not(.d-alert-with-button)::before {\n      left: var(--padding-x);\n      position: absolute;\n      top: var(--padding-y);\n    }\n  }\n\n  &:empty {\n    display: none;\n  }\n\n  &:where(:not(:last-child)) {\n    margin-bottom: var(--margin-bottom);\n  }\n\n  .d-alert--text {\n    display: block;\n  }\n\n  p:not(:last-child) {\n    margin-bottom: var(--p-margin);\n  }\n\n  /** @TechnicalDebt CADENZA-43087 */\n  ul {\n    list-style: square outside;\n    margin-block: 0;\n    margin-left: var(--space-5);\n    padding: 0;\n\n    /* reduce distance between bullet point and text to 4px */\n    li span {\n      left: -6px;\n      position: relative;\n    }\n  }\n\n  ul:has(> li > .d-label-with-icon) {\n    list-style-type: none;\n    margin-left: 0;\n  }\n\n  .title {\n    font-weight: var(--bold-font-weight);\n\n    &:empty {\n      display: none;\n    }\n  }\n}\n\n.d-alert-hint {\n  --bg: var(--alert-color-hint-background);\n  --border-color: var(--color-gray-04);\n  --color: var(--alert-color-hint);\n}\n\n.d-alert-success {\n  --bg: var(--alert-color-success-background);\n  --border-color: var(--color-success-04);\n  --color: var(--alert-color-success);\n  --icon: url('~@disy/cadenza-icons/check.svg');\n}\n\n.d-alert-info {\n  --bg: var(--alert-color-info-background);\n  --border-color: var(--color-info-04);\n  --color: var(--alert-color-info);\n  --icon: url('~@disy/cadenza-icons/info.svg');\n}\n\n.d-alert-warning {\n  --bg: var(--alert-color-warning-background);\n  --border-color: var(--color-warning-04);\n  --color: var(--alert-color-warning);\n  --icon: url('~@disy/cadenza-icons/warning.svg');\n}\n\n.d-alert-error {\n  --bg: var(--alert-color-error-background);\n  --border-color: var(--color-error-04);\n  --color: var(--alert-color-error);\n  --icon: url('~@disy/cadenza-icons/error.svg');\n}\n\n:where(.dark-bg) {\n  .d-alert-success {\n    --border-color: var(--color-success-05);\n  }\n\n  .d-alert-info {\n    --border-color: var(--color-info-05);\n  }\n\n  .d-alert-warning {\n    --border-color: var(--color-warning-05);\n  }\n\n  .d-alert-error {\n    --border-color: var(--color-error-05);\n  }\n}\n\n.d-alert-small,\n.d-alert-xs {\n  &.d-alert-with-button .d-alert--text::before,\n  &:not(.d-alert-with-button)::before {\n    float: left;\n    margin-right: var(--icon-gap);\n    margin-top: calc(-1 * var(--text-offset));\n  }\n}\n\n/*\n * Unfortunately, the alert size default is not sensible, because usually we use the small size.\n * To mitigate issues with people forgetting to apply the small size, we make default alerts\n * *look* like small alerts in modals and popups.\n */\n:where(.d-modal, .d-popup) .d-alert,\n.d-alert-small {\n  --icon-size: var(--icon-size-xs);\n  --margin-bottom: var(--space-2);\n  --p-margin: var(--space-1);\n  --padding-y: var(--space-2);\n}\n\n.d-alert-xs {\n  --icon-gap: var(--space-05);\n  --margin-bottom: var(--space-1);\n  --p-margin: var(--space-1);\n\n  /* Colors */\n  --alert-color-success: var(--alert-xs-color-success);\n  --alert-color-info: var(--alert-xs-color-info);\n  --alert-color-warning: var(--alert-xs-color-warning);\n  --alert-color-error: var(--alert-xs-color-error);\n\n  background-color: transparent;\n  border: none;\n  padding: 0;\n\n  @media (--hover) {\n    --icon-size: var(--icon-size-xs);\n  }\n}\n\n.d-alert-with-button {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n\n  & .d-alert--text + * {\n    margin-left: var(--space-2);\n  }\n}\n\n.d-alert-with-button-bottom {\n  --button-gap: var(--space-2);\n\n  & .d-alert--text ~ * {\n    margin: var(--button-gap) var(--button-gap) 0 0;\n  }\n\n  &.d-alert-small {\n    --button-gap: var(--space-1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
